import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'reactstrap';
import { profileActions } from '../../../core/profile/actions';
import { EditForm } from './EditForm';
import { convertCamelCase, passwordStrengthChecker } from '../../../core/helper';
import { getSystemById, systemActions } from '../../../core/system';
import { SYSTEM_ID_SENIORITIES } from '../../../core/constants';

const emailRegex = RegExp(
    /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
);

export const UserEditInfo = ({toggleShowForm}) => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const profile = useSelector(state => state.profile);
    const seniorities = useSelector(state => getSystemById(state, SYSTEM_ID_SENIORITIES));

    const [formErrors, setformErrors] = useState({
        firstName: '',
        lastName: '',
        email: profile.error?.data?.email || '',
        confirmEmail: '',
        currentPassword: '',
        password: '',
        confirmPassword: '',
        seniority: '',
    });
    const [inputValues, setInputValues] = useState({
        firstName: profile?.data?.first_name || user?.first_name,
        lastName: profile?.data?.last_name || user?.last_name,
        email: profile?.data?.email || user?.email,
        confirmEmail: '',
        currentPassword: '',
        password: '',
        confirmPassword: '',
        seniority: profile?.data?.seniority?.id || user?.seniority?.id,
    });
    const strength = passwordStrengthChecker(inputValues.password)

    useEffect(() => {
        dispatch(systemActions.loadSystem(SYSTEM_ID_SENIORITIES))

        return () => {

        }
    }, [dispatch])

    useEffect(() => {
        if (profile.error && profile.error.data) {
            const errors = profile.error.data;
            let updatedErrors = { ...formErrors };

            Object.keys(errors).forEach(key => {
                const camelCaseKey = convertCamelCase(key);

                updatedErrors = {
                    ...updatedErrors,
                    [camelCaseKey]: errors[key][0]
                };
            });

            setformErrors(updatedErrors);
        }
    }, [profile.error])

    const handleInputChange = async ({ target }) => {
        const { name, value } = target;

        switch (name) {
            case "firstName":
                formErrors.firstName =
                    value.length < 1 ? "Minimum 1 characters required" : "";
                break;
            case "lastName":
                formErrors.lastName =
                    value.length < 1 ? "Minimum 1 characters required" : "";
                break;
            case "email":
                !value ? formErrors.email = "" :
                    formErrors.email = emailRegex.test(value)
                        ? ""
                        : "Invalid email address";
                formErrors.confirmEmail = (inputValues.confirmEmail && inputValues.confirmEmail !== value)
                    ? "Emails do not match"
                    : ""
                break;
            case "currentPassword":
                formErrors.currentPassword = "";
                break;
            case "confirmEmail":
                let matchEmail = inputValues.email === value ? '' : 'Emails do not match';
                !value ? formErrors.confirmEmail = "" :
                    formErrors.confirmEmail = emailRegex.test(value)
                        ? matchEmail
                        : "Invalid email address";
                break;
            case "password":
                formErrors.password =
                    value && value.length < 8 ? "Minimum 8 characters required" : "";
                formErrors.confirmPassword = (inputValues.confirmPassword && inputValues.confirmPassword !== value)
                    ? "Passwords do not match"
                    : ""
                break;
            case "confirmPassword":
                let matchPass = inputValues.password === value ? "" : 'Passwords do not match';
                !value ? formErrors.confirmPassword = "" :
                    formErrors.confirmPassword = value.length < 8 ? "Minimum 8 characters required" : matchPass;
                break;
            default:
                break;
        }

        setInputValues({
            ...inputValues,
            [name]: value
        });
    }

    const onSubmitUpdateInfo = async (e) => {
        e && e.preventDefault();
        if (formValid()) {
            const info_profile = {
                first_name: inputValues.firstName,
                last_name: inputValues.lastName,
                current_password: inputValues.currentPassword,
                password: inputValues.password,
                confirm_password: inputValues.confirmPassword,
                email: inputValues.email === user.email ? '' : inputValues.email,
                seniority_id: inputValues.seniority
            }

            dispatch(profileActions.updateProfile(info_profile));
        }
    }

    useEffect(() => {
        if (profile.success)
            window.location.reload();
    }, [profile.success]);

    const formValid = () => {
        let valid = true;
        let inputValuesRequired = ['firstName', 'lastName', 'seniority']

        // validate form errors being empty
        Object.values(formErrors).forEach(val => {
            val.length > 0 && (valid = false);
        });

        // validate the form was filled out
        Object.keys(inputValues).forEach(key => {
            if (inputValuesRequired.includes(key)) {
                (inputValues[key] == '' || inputValues[key] == undefined) && (valid = false);
            }
        });

        (inputValues.password !== "" && inputValues.confirmPassword === "") && (valid = false);

        (inputValues.email !== user.email && inputValues.confirmEmail === "") && (valid = false);


        if (inputValues.password !== "" && strength === 'Too weak!') valid = false

        return valid;
    };

    return (
        <div className="w-100">
            <Container fluid="md" className='mx-auto p-0'>
                <div className='pt-md-3 px-md-3 rounded border-md'>
                    <div className='d-flex justify-content-between mb-3'>
                        <h1 className='mb-0 libre-caslon-text-regular h3-md h4'>My Profile</h1>
                    </div>
                    <EditForm
                        inputValues={inputValues}
                        handleInputChange={handleInputChange}
                        onSubmitUpdateInfo={onSubmitUpdateInfo}
                        formErrors={formErrors}
                        formValid={formValid}
                        strength={strength}
                        lists={
                            {
                                seniorities: seniorities?.items,
                            }
                        }
                        toggleShowForm={toggleShowForm}
                    />
                </div>
            </Container>
        </div>
    )
}
